/**
 * Centralized logo file paths.
 * Single source of truth for all logo references across the application.
 */

export const LOGO_PATHS = {
  /** 16x16 favicon */
  favicon16: '/favicon-16x16.png',
  /** 32x32 favicon */
  favicon32: '/favicon-32x32.png',
  /** Standard favicon.ico */
  faviconIco: '/favicon.ico',
  /** Apple touch icon (180x180) */
  appleTouch: '/apple-touch-icon.png',
  /** Android Chrome icon 192x192 */
  android192: '/android-chrome-192x192.png',
  /** Android Chrome icon 512x512 */
  android512: '/android-chrome-512x512.png',
  /** Main transparent logo (500x500) - used in Logo component */
  mainTransparent: '/emailferret_512-transparent.png',
} as const;

/**
 * Get the logo path for SEO/structured data purposes.
 * Uses the highest quality version (512x512).
 */
export function getLogoPathForSEO(): string {
  return LOGO_PATHS.android512;
}
